// extracted by mini-css-extract-plugin
export default {"questionWrapper":"AbilityQuestion-module__questionWrapper__KNeta","question":"AbilityQuestion-module__question__+6DuK","options":"AbilityQuestion-module__options__dmU8h"};